import { getExportedJSONData, setTagData } from './editorActions';
import { setupCanvases } from './canvasActions';

export const modifyForNLIS = () => {
    return (dispatch, getState) => {
        const store = getState();
        let data = getExportedJSONData(store);

        let { regions, styles } = data;

        let objectRenameMapping = {};

        // Ensure all regions are going to the custom one
        Object.values(regions).forEach(region => {
            const { id, side } = region;

            data.regions[id].activeStyle = `style-custom-${side}`;
        });

        // Get stuff that needs to be removed
        Object.values(styles).forEach(style => {
            const { side, name, layers, id, region } = style;

            if(name.toLowerCase() == 'custom') {
                objectRenameMapping[id] = `style-custom-${side}`;

                layers.forEach(layer => {
                    if(!layer.includes('custom')) {
                        const layerID = layer.replace('layer-', '');
                        objectRenameMapping[layer] = `layer-custom-${side}-${layerID}`;
                    }
                });
            }
            else {
                // Remove layers and styles
                console.log('Removing style', id);
                if(typeof(data.regions[region]) != 'undefined') {
                    data.regions[region].styles = data.regions[region].styles.filter(e => e !== id);
                }
                delete data.styles[id];

                console.log('Removing layers', layers);
                layers.forEach(id => {
                    delete data.layers[id];
                });
            }
        });


        // Rename the styles
        let stringifyData = JSON.stringify(data);
        Object.entries(objectRenameMapping).forEach(([oldID, newID]) => {
            let regex = new RegExp(oldID, 'g');
            stringifyData = stringifyData.replace(regex, newID);
        });

        let finalData = JSON.parse(stringifyData);

        // Immediately copy to clipboard
        console.log('Stringify JSON', stringifyData);
        copyToClipboard(stringifyData);

        // Let's dump
        Promise.all([
            dispatch(setTagData(finalData)),
        ]).then(() => {
            dispatch(setupCanvases());
        });
    };
};

export const copyToClipboard = function(secretInfo) {
    let $body = document.getElementsByTagName('body')[0];
    let $tempInput = document.createElement('INPUT');
    $body.appendChild($tempInput);
    $tempInput.setAttribute('value', secretInfo);
    $tempInput.select();
    document.execCommand('copy');
    $body.removeChild($tempInput);
};
